import React from 'react';
import { Container } from 'react-bootstrap';

export function FooterSimple() {
  return (
    <div id="footer-simple">
      <a href="https://menbirinchi.uz">menbirinchi.uz</a>
    </div>
  );
}

export default function Footer({ mobileOnly = false }) {
  return (
    <footer className={mobileOnly ? 'd-block d-md-none' : null}>
      <Container>
        <div>
          <a href="https://menbirinchi.uz">menbirinchi.uz</a>
        </div>
      </Container>
    </footer>
  );
}
